import Cookies from 'js-cookie';

export default class AgeConfirmationModal {
  constructor() {
    const modalNamespace = 'age-confirmation';
    this.modal = window.modalManager.idModalMap.get(modalNamespace);
    this.modal.locked = true;
    this.cookieNamespaceHasSeenPopup = 'checked-age-egmonts-garden-d';
    this.cookieNamespaceIsTooYoung = 'age-too-young-egmonts-garden';
    this.section_question = this.modal.element.querySelector('.modal-center-content__question');
    this.section_to_young = this.modal.element.querySelector('.modal-center-content__too-young');
    this.modalTriggerelement = document.querySelector('.js-modal-trigger--age-confirmation');

    if (!Cookies.get(this.cookieNamespaceHasSeenPopup)) {
      this.modalTriggerelement.click();
      // eslint-disable-next-line no-empty
    } else if (!Cookies.get(this.cookieNamespaceIsTooYoung)) {
    } else {
      this.section_question.classList.remove('active');
      this.section_to_young.classList.add('active');
      this.modalTriggerelement.click();
    }

    this.modal.element.querySelector('.age-modal-old-enough').addEventListener('click', () => {
      this.modal.hide();
      Cookies.set(this.cookieNamespaceHasSeenPopup, '1', { expires: 365 });
    });

    this.modal.element.querySelector('.age-modal-too-young').addEventListener('click', () => {
      Cookies.set(this.cookieNamespaceHasSeenPopup, '1', { expires: 365 });
      Cookies.set(this.cookieNamespaceIsTooYoung, '1', { expires: 365 });
      this.section_question.classList.remove('active');
      this.section_to_young.classList.add('active');
    });
  }
}
